// extracted by mini-css-extract-plugin
module.exports = {"Container":"ResultDelivery_Container__8FBdp","Delivery":"ResultDelivery_Delivery__PiYQg","Text":"ResultDelivery_Text__T2k5K"};